import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/principioActivo';
import PrincipioActivo from './PrincipioList';


const ms2p = (state) => {
  return {
    ...state.rs_principioActivo,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(PrincipioActivo);